import { render, staticRenderFns } from "./LinkSetting.vue?vue&type=template&id=a3626f08&scoped=true"
import script from "./LinkSetting.vue?vue&type=script&lang=js"
export * from "./LinkSetting.vue?vue&type=script&lang=js"
import style0 from "./LinkSetting.vue?vue&type=style&index=0&id=a3626f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3626f08",
  null
  
)

export default component.exports